import { http } from './common';

const providerDataLanding = async (options) => {
    return http.post(`/api/v1/cms/configuration/providerdata`, options);
};

export {
    providerDataLanding
}